export const clientsearchtitle = "Please provide the following details to check if the person is available on our platform"
export const familymembersearchtitle = "Please enter your details"